const stickyHeader = {
    header: document.getElementById('header') as HTMLElement,
    mainContent: document.getElementById('mainContent')as HTMLElement,


    init() {
        this.setClass();
        this.activeClass();

    },

    setClass() {

        document.addEventListener('scroll', (e) => {
            let st = window.pageYOffset || document.documentElement.scrollTop;        

      

            if (st === 0) {
                this.header.classList.remove('up');
                this.header.classList.remove('down');
                this.mainContent.classList.remove('up');
                this.mainContent.classList.remove('down');
               

            } else if (st !== 0 && st < 30) {
                 
                this.header.classList.add('up');
                this.header.classList.remove('down');
                this.mainContent.classList.add('up');
                this.mainContent.classList.remove('down');
            
            }else {
                this.header.classList.remove('up');
                this.header.classList.add('down');
                this.mainContent.classList.remove('up');
                this.mainContent.classList.add('down');

            }

        })
    },

    activeClass() {
        const activeLink = document.querySelectorAll('.jsLvl1');
        activeLink.forEach(button => {
            button.addEventListener('click', function () {
                activeLink.forEach(btn => btn.classList.remove('activeClass'));
                button.classList.add('activeClass');
            });
        });
    },


}

export default stickyHeader;